/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_course_attachments_messages_copyfailed1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL 복사에 실패했습니다`)
};

const en_course_attachments_messages_copyfailed1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy URL`)
};

const ja_course_attachments_messages_copyfailed1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URLのコピーに失敗しました`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const course_attachments_messages_copyfailed1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.course_attachments_messages_copyfailed1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("course_attachments_messages_copyfailed1", locale)
	if (locale === "ko") return ko_course_attachments_messages_copyfailed1(inputs)
	if (locale === "en") return en_course_attachments_messages_copyfailed1(inputs)
	return ja_course_attachments_messages_copyfailed1(inputs)
};
export { course_attachments_messages_copyfailed1 as "course_attachments_messages_copyFailed" }